import React from "react";

export type LayoutSmContainerContextType = {
  renderSection: (params: { segment: string; title?: string; content: () => React.ReactNode }) => React.ReactNode;
  renderHeadMain: () => React.ReactNode;
  renderHeadStack: (params: { title: string; onBack: () => void }) => React.ReactNode;
  renderHeadLg: (params: { onClose: () => void }) => React.ReactNode;
  renderDelimiter: () => React.ReactNode;
};

export const LayoutContext = React.createContext<LayoutSmContainerContextType | null>(null);
